import { StepForm } from '@iq-firebolt/client'
import fireboltBlueberry from '@iq-firebolt/blueberry-theme'
import useStepTemplate from 'hooks/useStepTemplate'
import useRedirectTransitionError from 'hooks/useRedirectTransitionError'

import LoadingStep from 'components/StepTemplates/LoadingStep'
import FormContainer from 'components/common/FormContainer'
import ActionButtons from 'components/common/ActionButtons'

import './style.styl'
import { useBankDataHook } from './hook'
import { FormTitle } from 'components/common/FormTitle'

const SecondStep = ({ fireboltStep }) => {
  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
  })

  useBankDataHook()

  const errorRedirect = {
    'in_analysis': '/produto/bb-ourocard/pedido-em-analise',
  }

  const { redirectTransitionError } = useRedirectTransitionError(errorRedirect)

  return redirectTransitionError ? (
    <FormContainer imageSrc="images/bb/ourocard-novo.webp">
      <div className="bbourocard-bank-data-step" >
        <FormTitle title="Sobre seus dados bancários" hasRequiredFieldWarning />
      <StepForm
        theme={fireboltBlueberry}
        customActionsChild={({ formData }) => (
          <ActionButtons
            formData={formData}
            onGoBack={handleGoBackform}
            beforeSubmitStep={runBeforeChangeStep}
          />
        )}
      />
      </div>
      
    </FormContainer>
  ) : (
    <LoadingStep />
  )
}

export default SecondStep
